module.exports = __webpack_public_path__ + "media/images/341-fcd8bf3babd1711b367b1eca7f2384df.gif";